<template>
  <v-container>
    <v-toolbar>
      <v-app-bar-nav-icon @click="nav2page('Settings')">
        <v-icon>mdi-arrow-left-circle-outline</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>{{ $t("main_title") }} &#x2022; {{ $t("device_pairing") }}</v-toolbar-title>
    </v-toolbar>
    <!--v-container-->
    <v-card class="mx-auto">
      <v-form ref="form" v-model="isFormValid">
        <v-text-field minLength=5 maxLength=80 v-model="device_settings.name" :label="$t('device_pairing_device_name')"
          required :rules="[rules.required, rules.counter]"></v-text-field>
        <v-text-field maxLength=100 v-model="device_settings.qrcode" :readonly="true"
          :label="$t('device_pairing_scan_code')"></v-text-field>

        <v-btn text @click="send_device_pair_request(device_settings)" :disabled="!isFormValid" color=blue>
          <v-icon>mdi-monitor-multiple</v-icon>
          {{ $t('device_pairing_request') }}
        </v-btn>
        <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>

      </v-form>
      <!--/v-container-->
      <v-dialog v-model="deviceadd_success_show" scrollable max-width="300px">
        <v-card>
          <v-card-title>{{ $t("device_pairing") }}</v-card-title>
          <v-card-text>{{ $t("device_pairing_ok_message") }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="deviceadd_success_show = false">{{
              $t("ok") }}</v-btn>
            <!--
          <v-btn color="red darken-1" text @click="user_user_delete()">{{ $t("profile_delete_account_select") }}</v-btn>
          -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import messenger from "../messenger";
import router from "../router";
// create QRCode - Reader from https://dimoff2000.medium.com/how-to-add-a-qr-and-barcode-scanner-to-your-vue-js-app-545c23f31969
import { StreamBarcodeReader } from "vue-barcode-reader";


export default {
  name: 'DeviceAdd',
  components: {
    StreamBarcodeReader
  },
  data() {
    return {
      isFormValid: false,
      deviceadd_success_show: false,
      device_settings: { "name": "", "qrcode": "" },
      rules: {
        required: value => !!value || this.$t('edit_min_chars'),
        counter: value => value.length >= 5 || this.$t('profile_min_chars'),
      },
      camera: null,
      barcodes: [],

    }
  },
  methods: {
    nav2page(page) {
      router.push({ name: page, params: { user_info: this.user_info } });
    },
    send_device_pair_request() {
      messenger.emit("device_pair_request", {
        device_settings: this.device_settings
      });
      //this.deviceadd_success_show = true
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
      this.device_settings.qrcode = text
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
  },
  created() {
    this.user_info = this.$route.params.user_info
    console.log("user_info", this.user_info)
  },
  mounted() {
    navigator.mediaDevices.getUserMedia({ audio: false, video: true })
      .then(stream => this.camera = stream)
  },
  watch: {

  }
}
</script>
